export enum ContractStatusEnum {
  NEW = 'new',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
  UNDER_MODIFICATION = 'under_modification',
}
